import * as React from "react";
import { createPortal } from 'react-dom';
import * as Models from '../models/index';
import { useEffect, useReducer, useState } from "react";
import { JobsService, SearchIn } from '../services/JobsService';
import { format } from 'date-fns';
import { Collapse } from 'react-collapse';
import classNames from 'classnames';
import ReactPaginate from 'react-paginate';

const PAGE_SIZE = 20;

type Props = {
    joinBlakesUrl: string;
    blakesUrl: string;
    dictionary: { [key: string]: string; };
    searchOnSite: 'blakes' | 'joinblakes';
}

type State = {
    keywords: string;
    searchOnSite: string;
    showOnlyTextInput: boolean;
}

const initialState: State = {
    keywords: '',
    searchOnSite: 'blakes',
    showOnlyTextInput: true
}

const SearchRedirect = (props: Props) => {

    const getInitialState = () => {
        let result = initialState;
        result.searchOnSite = props.searchOnSite;
        return result;
    };

    const [state, setState] = useReducer(
        (prevState: State, newState: Partial<State>) => ({ ...prevState, ...newState }),
        getInitialState()
    );


    const search = () => {

        let url = state.searchOnSite == 'blakes'
            ? props.blakesUrl.replace('{0}', state.keywords)
            : props.joinBlakesUrl + '?q=' + encodeURIComponent(state.keywords);

        window.location.href = url;
        console.log('searching for: ' + state.keywords);
    }


    return (<React.Fragment>
        <div className="grid-x">
            <div className="cell auto">
                <div className="fieldset-search">
                    <i className="fa-solid fa-magnifying-glass" aria-hidden="true" tabIndex={-1}></i>
                    <label htmlFor={"txtMobileSearch" + props.searchOnSite} tabIndex={-1} className="show-for-sr">{props.dictionary['placeholder']}</label>
                    <input type="text"
                        id={"txtMobileSearch" + props.searchOnSite}
                        placeholder={props.dictionary['placeholder']}
                        value={state.keywords}
                        className="form-control"
                        tabIndex="0"
                        onChange={(e) => { setState({ keywords: e.currentTarget.value }) }}
                        onFocus={(e) => { setState({ showOnlyTextInput: false }) }}
                        onKeyDown={(e) => {
                            if (e.key == "Enter") // enter
                                search();
                        }}
                        aria-label="search"
                    />
                </div>
            </div>
            {!state.showOnlyTextInput &&
                <div className="cell shrink">
                    <button type="button" className="btn btn-link" onClick={(e) => { setState({ showOnlyTextInput: true }) }}>{props.dictionary['cancel']}</button>
                </div>
            }
        </div>
        {!state.showOnlyTextInput && <div className="grid-x">
            <fieldset className="cell">
                {['joinblakes', 'blakes']
                    .map(x => <React.Fragment>
                        <input className="form-control" type="radio" id={"searchOnSite_" + props.searchOnSite + x} name={"searchOnSite_" + props.searchOnSite} value={x} checked={state.searchOnSite == x}
                            onChange={(e) => { setState({ searchOnSite: e.currentTarget.value }) }}
                        /><label key={x} htmlFor={"searchOnSite_" + props.searchOnSite + x}>{x == "blakes" ? "Blakes.com" : "Join Blakes"}</label>
                    </React.Fragment>)}
            </fieldset>
        </div>}
    </React.Fragment>
    );
}

export default SearchRedirect;